import action from './action'

export default {
    getStocks(params) {
        return action.request('get_welcom_stocks',{query: JSON.stringify(params)})
    }
}
